import { withAssign } from '@reatom/framework'

import { type AsyncStateN } from '@blade/std-lib'
import { reatomPnlCalendarView } from '@root/features/portfolio/user-pnl-chart'

import type { Action, Atom, AtomMut } from '@reatom/framework'
import type { UserPnlCalendarModel } from '@root/features/portfolio/user-pnl-chart'
import type { Entry } from '@root/features/portfolio/user-pnl-chart/model/pnl-chart-entry'
import type { UnknownError } from '@root/shared'

export const reatomUserTradingProfilePnlCalendar = (args: {
  dataAtom: Atom<AsyncStateN.AsyncStateN<UnknownError, Array<Entry>>>
  dateAtom: AtomMut<Date>
  retryAction: Action<[]>
}): UserPnlCalendarModel => {
  /* eslint-disable @reatom/unit-naming-rule */
  const calendarView = reatomPnlCalendarView(
    args.dataAtom,
    args.dateAtom,
    'pnlCalendar',
  )

  return args.dataAtom.pipe(
    withAssign(() => ({
      date: args.dateAtom,
      retryAction: args.retryAction,
      ...calendarView,
    })),
  )
}
